module.exports = __webpack_public_path__ + "img/1480116589.db0707a2.jpg";